import { Application } from '@hotwired/stimulus'
import AcknowledgementController from '../controllers/acknowledgement_controller'
import NestedFormController from '../controllers/nested_form_controller'
import TenantTemplatesController from '../controllers/tenant_templates_controller'

const application = Application.start()
application.register('acknowledgement', AcknowledgementController)
application.register('nested-form', NestedFormController)
application.register('tenant-templates', TenantTemplatesController)

export default application
